<template>
    <VContainer fluid>
        <VRow>
            <VSpacer cols="3" />
            <VCol class="pa-10">
                <content-doc path="legal/privacy" :head="false" />
            </VCol>
            <VSpacer cols="3" />
        </VRow>
    </VContainer>
</template>

<script lang="ts" setup></script>

<style scoped></style>
